import {Pipe, PipeTransform} from '@angular/core';
import {LanguageService} from "../services/resources/language.service";
import {TranslationModel} from "../models/resources/translation.model";

@Pipe({
  name: 'language',
  standalone: true
})
export class LanguagePipe implements PipeTransform {

  constructor(private languageService: LanguageService) {
  }

  transform(object: any): { name: string } {
    const fallback = { name: '' };
    if (!this.languageService.activeLanguage())
      return fallback;
    const activeId = this.languageService.activeLanguage()!.id;
    if (typeof object === 'string')
      return { name: object };
    if (Array.isArray(object)) {
      const t = object.find((x: { languageId: number }) => x.languageId === activeId);
      const text = t?.text ?? object[0]?.text ?? '';
      return { name: text };
    }
    if (object?.translations) {
      const t = object.translations.find((t: TranslationModel) => t.languageId === activeId);
      return t ? { name: t.text } : fallback;
    }
    return fallback;
  }
}
